/**
 * The consumer care team's own contacts — the one route a consumer member has to a human.
 *
 * ⚠ THREE SPELLINGS OF ONE NUMBER, because the surfaces that print it genuinely differ and
 * every one of them would otherwise reformat another's string:
 *
 *   • `_E164` is what a dialler needs, and the only form `tel:` accepts.
 *   • `_INTERNATIONAL` is what the care-team tile interpolates ("…at +1 888-239-1354"),
 *     matching the shape the enterprise phone-support endpoint returns for that same slot.
 *   • `_GROUPED` is what the clinician-messaging copy prints, where the design draws the
 *     number as a bare grouped US number a member reads back over the phone.
 *
 * ⚠ THESE LIVE HERE RATHER THAN BESIDE EITHER READER, and that is a REVERSAL of the previous
 * decision (they were module-local to `packages/messages/src/lib/careTeam.tsx`, on the
 * argument that all three call sites in that package wanted the same pair and handing out
 * the strings would only invite a fourth spelling). What changed: a SECOND package now needs
 * the identical pair. `useGetPhoneSupportNumberForUser` in the member SPA answers this number
 * for consumer members, so the literals are read from two workspaces that cannot import each
 * other. Duplicating them is how `care@get-carrot.com` already came to exist in two places —
 * see the note on CARE_TEAM_EMAIL.
 */
export const CARE_TEAM_PHONE_E164 = "+18882391354"
export const CARE_TEAM_PHONE_INTERNATIONAL = "+1 888-239-1354"
export const CARE_TEAM_PHONE_GROUPED = "888-239-1354"

/**
 * ⚠ NOT THE ONLY COPY IN THE REPO — `receiptData.ts` (packages/convex) carries the same
 * literal as a receipt's `supportEmail`. Not consolidated here because that package is not
 * wired to `@internal/constants`; noted so that a change to the care team's address is known
 * to be a change in two places.
 */
export const CARE_TEAM_EMAIL = "care@get-carrot.com"
